export const izjava4Lookup =
    [
        {
            id: "1", ime: "беше суспендиран или повлечен"
        }
    ]